<template>
  <div class="BarAudio">
    <range-slider
      min="0"
      max="10000"
      step="1"
      v-model="position"
      @change="onChange"
      @input="onInput"
    ></range-slider>
    <div class="interface">
      <button
        :class="['play-pause', getIcon]"
        @click="onPlayPauseClick"
      ></button>
      <div class="title" v-if="isLoading">Loading…</div>
      <router-link
        v-else
        class="title hover"
        ref="title"
        :to="broadcast.pageUrl"
      >
        {{ broadcast.title }}
      </router-link>
      <div class="timecode" v-if="isError"></div>
      <div v-else class="timecode">{{ timecode }}</div>
      <button
        class="icon icon-button-close close"
        @click="onCloseClick"
      ></button>
    </div>
  </div>
</template>

<script>
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";

export default {
  name: "BarAudio",
  components: { RangeSlider },
  data() {
    return {
      disabled: false,
    };
  },
  methods: {
    onCloseClick() {
      this.$store.dispatch("closeBroadcast");
    },
    onPlayPauseClick() {
      this.$store.dispatch("toggleBroadcast");
    },
    onInput() {
      if (!this.disabled) {
        this.disabled = true;
        this.$store.dispatch("pauseBroadcast");
      }
    },
    onChange(value) {
      let scaled = (value * this.broadcast.duration) / 10000;
      this.$store.dispatch("seekBroadcast", scaled);
      this.$nextTick(() => this.$store.dispatch("playBroadcast"));
      this.disabled = false;
    },
  },
  computed: {
    broadcast() {
      return this.$store.state.audio.broadcast;
    },
    position: {
      get() {
        let position = parseInt(this.broadcast.position);
        let scaled = (position / this.broadcast.duration) * 10000;
        return scaled || 0;
      },
      set(value) {
        return value;
      },
    },
    isLinkVisible() {
      return (
        this.broadcast.pageUrl && this.$route.path !== this.broadcast.pageUrl
      );
    },
    getIcon() {
      return this.broadcast.paused ? "icon-player-play" : "icon-player-pause";
    },
    timecode() {
      return [this.broadcast.position, this.broadcast.duration]
        .map(formatTime)
        .join("/");
    },
    isLoading() {
      return (this.broadcast.position && this.broadcast.duration) === 0;
    },
    isError() {
      return (this.broadcast.position && this.broadcast.duration) === 1;
    },
  },
};

function formatTime(duration) {
  var seconds = parseInt(duration % 60);
  var minutes = parseInt((duration / 60) % 60);
  var hours = parseInt((duration / (60 * 60)) % 24);

  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return [hours, minutes, seconds].filter((str) => str).join(":");
}
</script>

<style scoped>
.BarAudio {
  background: #fff;
  position: relative;
  padding: 0.2rem 2rem 0 2rem;
}

.interface {
  display: flex;
  padding: 0.6rem 0 1rem 0; /* extra top/bottom padding to accomodate progress bar */
}

.play-pause {
  margin-right: 2rem;
  position: relative;
  width: 1.5rem;
  z-index: 3;
}

.track {
  background: #ccc;
  position: absolute;
  top: 0;
  left: 2rem;
  right: 2rem;
  width: calc(100% - 4rem);
  height: 3px;
  z-index: 2;
  pointer-events: none;
}

.progress {
  background: var(--accent);
  height: 100%;
}

.title {
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 2rem;
}

.timecode {
  margin-left: auto;
}

.icon {
  position: relative;
  z-index: 3;
}

.icon::before {
  content: "";
  display: block;
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: transparent;
}

.icon-button-close {
  margin-left: 2rem;
}

a {
  position: relative;
  z-index: 9;
}

/**
 * vue-range-slider
 */
.BarAudio >>> .range-slider {
  width: calc(100% - 4rem);

  padding-left: 0;
  padding-right: 0;

  position: absolute;
  top: -1rem;
  left: 2rem;
  right: 2rem;

  cursor: grab;
  z-index: 4;
}

.BarAudio >>> .range-slider-fill {
  background: var(--accent);
  border-radius: 0;
  height: 3px;
}

.BarAudio >>> .range-slider-rail::before,
.BarAudio >>> .range-slider-rail::after {
  content: "";
  display: block;
  position: absolute;
  height: 3px;
  background: #fff;
  width: 2rem;
  top: 0;
  left: -2rem;
  pointer-events: none;
}

.BarAudio >>> .range-slider-rail::after {
  left: auto;
  right: -2rem;
}

.BarAudio >>> .range-slider-rail {
  background: #ccc;
  border-radius: 0;
  height: 3px;
}

.BarAudio >>> .range-slider-knob {
  opacity: 0;
  cursor: grab;
}

/**
 * mobile
 */

@media (max-width: 920px) {
  .BarAudio {
    padding-top: 0.1rem;
  }

  .interface {
    padding: 1.3rem 0 1.4rem 0;
  }

  .timecode {
    display: none;
  }

  .play-pause {
    display: block;
    margin-right: 1.5rem;
  }

  .BarAudio >>> .range-slider {
    width: 100%;
    left: 0;
    right: 0;
  }

  .BarAudio >>> .range-slider-rail::before,
  .BarAudio >>> .range-slider-rail::after {
    display: none;
  }
}
</style>

<style>
@media (min-width: 851px) {
  .bottom .BarAudio .interface {
    padding-bottom: 0.9rem;
  }
}
</style>
